const Loader = () => {
	return (
		<section className="loader">
			<i className="fas fa-spinner fa-spin" />
		</section>
	);
};

export default Loader;
